/**Import reacts section */
import React, { useState } from 'react'
import propTypes from 'prop-types'
import {
	SERVICE_PROVIDER_TECHNICIAN,
	SERVICE_PROVIDER_MANAGER,
	PORTAL_ADMINISTRATOR,
	DISPATCHER,
	IMBERA_TECHNICIAN,
	SPARE_PARTS_IMBERA_USA,
	SALES_MANAGER,
	SALES_REPRESENTATIVE_MANAGER,
	CUSTOMER_MANAGER,
	CUSTOMER_TECHNICIAN,
	VISUALIZER
} from '../../../resources/RolesEnum'

import { useHistory } from 'react-router-dom'

/**Import components secction */
import DataGrid from '../../common/apsys.datagrid.materialui/DataGrid'
import { useServiceTableStyles } from '../../../resources/styles/ServicesListStyles'
import FilterSelect from '../../common/Filters/FilterSelect'
import FilterText from '../../common/Filters/FilterText'
import FilterDateRange from '../../common/Filters/FilterDateRange'
import SearchBox from '../../common/SearchToolbox'
import Authorization from '../../common/AuthorizationEvaluation'
import ReportDateRange from '../../common/ReportDateRange/ReportDateRange'
import { getOptions, getOptionsInternalUsers, GetWorkProcessStatusOptions, GetDispatchPhaseOptions } from '../../../store/helpers/FilterHelper'
import Configurator from '../../common/apsys.datagrid.materialui/PopperConfigurator'

/**Import material ui section */
import { Tooltip, Button, ButtonGroup, IconButton, CircularProgress } from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddTwoTone'
import ImportFile from '@material-ui/icons/CloudUpload'
import TuneIcon from '@material-ui/icons/TuneOutlined'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import GetAppIcon from '@material-ui/icons/GetApp'

/**
 * Service list co
 */
const ServicesTable = (props) => {
	/**Functions */
	const {
		onChangeSearchValue,
		onDownloadReportOpenServices,
		onFastDownloadReportOpenServices,
		onDownloadOpenServicesJson
	} = props
	const [isDownloadingJson, setIsDownloadingJson] = useState(false)

	/**Arrays */
	const {
		serviceProviders,
		salesRepresentatives,
		retails,
		internalUsers,
		isServicesOpen,
		redirectToCreateService,
		// handleCreatePossibleService,
		redirectToServiceDetail,
		userProfile,
		optionsStatus
	} = props
	/**String values */
	const { searchValue } = props
	/**String values */
	const { isDownloadReport } = props

	const classes = useServiceTableStyles()
	let history = useHistory()

	let representatives = getOptions(salesRepresentatives)
	let serviceProvider = getOptions(serviceProviders)
	let allRetailers = getOptions(retails)
	let allInternalUsers = getOptionsInternalUsers(internalUsers)
	let workProcessStatusOptions = GetWorkProcessStatusOptions()
	let dispatchPhaseOptions = GetDispatchPhaseOptions()

	/** Filter configurator state */
	const { filterConfiguration, onFilterConfigurationChange } = props
	const [filterConfiguratorAnchorEl, setFilterConfiguratorAnchorEl] = useState(null)

	const onFilterConfigChange = (configuration) => {
		if (onFilterConfigurationChange) {
			onFilterConfigurationChange(configuration)
		}
		setFilterConfiguratorAnchorEl(null)
	}

	/** Map filter keys to their data sources */
	const filterDataMap = {
		status: optionsStatus,
		salesRep: representatives,
		provider: serviceProvider,
		customer: allRetailers,
		dispatcher: allInternalUsers,
		techAssigned: allInternalUsers,
		workProcessStatus: workProcessStatusOptions,
		dispatchStatus: dispatchPhaseOptions
	}

	const onRowClick = (sender, item) => {
		if (redirectToServiceDetail) {
			redirectToServiceDetail(item.Token, item.Serie)
		}
	}

	/** Render filters based on configuration or fall back to default */
	const renderFilters = () => {
		if (!filterConfiguration || filterConfiguration.length === 0) {
			return renderDefaultFilters()
		}

		return filterConfiguration
			.filter((filterConfig) => filterConfig.visible)
			.map((filterConfig) => {
				if (filterConfig.type === 'text') {
					return (
						<FilterText
							key={filterConfig.key}
							nameFilter={filterConfig.title}
							nameFilterUrl={filterConfig.nameFilterUrl}
							userProfile={userProfile}
							roles={filterConfig.roles}
						/>
					)
				}
				if (filterConfig.type === 'dateRange') {
					return (
						<FilterDateRange
							key={filterConfig.key}
							nameFilter={filterConfig.title}
							startDateParam={filterConfig.startDateParam}
							endDateParam={filterConfig.endDateParam}
							userProfile={userProfile}
							roles={filterConfig.roles}
						/>
					)
				}
				return (
					<FilterSelect
						key={filterConfig.key}
						nameFilter={filterConfig.title}
						data={filterDataMap[filterConfig.key] || []}
						nameFilterUrl={filterConfig.nameFilterUrl}
						isVisibleSearch={filterConfig.isVisibleSearch}
						userProfile={userProfile}
						roles={filterConfig.roles}
					/>
				)
			})
	}

	/** Default filter rendering (fallback when no configuration is provided) */
	const renderDefaultFilters = () => {
		return (
			<>
				<FilterSelect
					nameFilter={'STATUS'}
					data={optionsStatus}
					nameFilterUrl={'statusFilter'}
					isVisibleSearch={false}
					userProfile={userProfile}
					roles={[
						SERVICE_PROVIDER_TECHNICIAN,
						SERVICE_PROVIDER_MANAGER,
						PORTAL_ADMINISTRATOR,
						DISPATCHER,
						IMBERA_TECHNICIAN,
						SPARE_PARTS_IMBERA_USA,
						SALES_MANAGER,
						SALES_REPRESENTATIVE_MANAGER,
						CUSTOMER_MANAGER,
						CUSTOMER_TECHNICIAN,
						VISUALIZER
					]}
				/>
				<FilterSelect
					nameFilter={'Sales rep'}
					data={representatives}
					nameFilterUrl={'representativesFilter'}
					isVisibleSearch={true}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
				<FilterSelect
					nameFilter={'Provider'}
					data={serviceProvider}
					nameFilterUrl={'serviceProviderFilter'}
					isVisibleSearch={true}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
				<FilterSelect
					nameFilter={'Customer'}
					data={allRetailers}
					nameFilterUrl={'retailersFilter'}
					isVisibleSearch={true}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
				<FilterSelect
					nameFilter={'Dispatcher'}
					data={allInternalUsers}
					nameFilterUrl={'dispatcherFilter'}
					isVisibleSearch={true}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
				<FilterSelect
					nameFilter={'Tech assigned'}
					data={allInternalUsers}
					nameFilterUrl={'teachAssignedFilter'}
					isVisibleSearch={true}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
				<FilterSelect
					nameFilter={'Work Process Status'}
					data={workProcessStatusOptions}
					nameFilterUrl={'workProcessStatusFilter'}
					isVisibleSearch={false}
					userProfile={userProfile}
					roles={[PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]}
				/>
			</>
		)
	}

	return (
		<>
			<div className={classes.root}>
				{/**Filters area: scrollable container */}
				<div style={{ display: 'flex', alignItems: 'center', overflow: 'auto', maxWidth: '55%', flexShrink: 0, gap: '8px' }}>
					{renderFilters()}
				</div>
				{/**Clean all filters button */}
				<Tooltip component='span' title='Clean filters'>
					<IconButton size='small' onClick={() => {
						history.push({ search: '' })
					}} style={{ marginLeft: '4px' }}>
						<DeleteIcon style={{ width: '19px', color: '#e74c3c' }} />
					</IconButton>
				</Tooltip>
				{/**Filter configurator */}
				{filterConfiguration && filterConfiguration.length > 0 && (
					<>
						<Tooltip title='Configure filters'>
							<IconButton
								size='small'
								color='primary'
								onClick={(event) =>
									setFilterConfiguratorAnchorEl(filterConfiguratorAnchorEl ? null : event.currentTarget)
								}
							>
								<TuneIcon fontSize='small' />
							</IconButton>
						</Tooltip>
						<Configurator
							open={filterConfiguratorAnchorEl ? true : false}
							anchorEl={filterConfiguratorAnchorEl}
							configuration={filterConfiguration}
							onConfigurationChange={onFilterConfigChange}
							onClickAway={() => setFilterConfiguratorAnchorEl(null)}
							saveButtonText='Save Filter Configuration'
						/>
					</>
				)}
				<div className={classes.grow}></div>
				<Authorization profile={userProfile} allowedRoles={[PORTAL_ADMINISTRATOR]}>
					<ButtonGroup component='span' size='small' variant='outlined' color='primary' className={classes.buttonsGroupContainer}>
						<Tooltip title='Download open services JSON'>
							<Button
								className={classes.buttonsGroup}
								disabled={isDownloadingJson}
								onClick={() => {
									setIsDownloadingJson(true)
									onDownloadOpenServicesJson()
										.catch(() => {})
										.finally(() => setIsDownloadingJson(false))
								}}
							>
								{isDownloadingJson ? <CircularProgress size={18} /> : <GetAppIcon />}
							</Button>
						</Tooltip>
					</ButtonGroup>
				</Authorization>
				<Authorization
					profile={userProfile}
					allowedRoles={[
						PORTAL_ADMINISTRATOR,
						DISPATCHER,
						IMBERA_TECHNICIAN,
						SERVICE_PROVIDER_MANAGER,
						SERVICE_PROVIDER_TECHNICIAN,
						SALES_MANAGER,
						SALES_REPRESENTATIVE_MANAGER,
						CUSTOMER_MANAGER,
						CUSTOMER_TECHNICIAN,
						VISUALIZER
					]}
				>
					<ReportDateRange onDownloadReport={onDownloadReportOpenServices} isDownloadReport={isDownloadReport} />
				</Authorization>
				<Authorization profile={userProfile} allowedRoles={[PORTAL_ADMINISTRATOR, DISPATCHER]}>
					<ReportDateRange
						onDownloadReport={onFastDownloadReportOpenServices}
						isDownloadReport={isDownloadReport}
						title='Fast Downloades'
					/>
				</Authorization>
				<ButtonGroup component='span' size='small' variant='outlined' color='primary' className={classes.buttonsGroupContainer}>
					{isServicesOpen && (
						<Authorization
							profile={userProfile}
							allowedRoles={[
								DISPATCHER,
								CUSTOMER_MANAGER,
								CUSTOMER_TECHNICIAN,
								SERVICE_PROVIDER_MANAGER,
								SERVICE_PROVIDER_TECHNICIAN,
								SALES_REPRESENTATIVE_MANAGER,
								SALES_MANAGER
							]}
						>
							<>
								{/* <Tooltip component='span' title='Create possible services'>
									<Button className={classes.buttonsGroup} onClick={handleCreatePossibleService} disabled={isDownloadReport}>
										<AddIcon />
									</Button>
								</Tooltip> */}
								<Tooltip component='span' title='Create service'>
									<Button className={classes.buttonsGroup} onClick={redirectToCreateService} disabled={isDownloadReport}>
										<AddIcon />
									</Button>
								</Tooltip>
								<Authorization profile={props.userProfile} allowedRoles={[SERVICE_PROVIDER_TECHNICIAN, SERVICE_PROVIDER_MANAGER]}>
									<Tooltip component='span' title='Import Comments History'>
										<Button onClick={props.openImportCommentsPanel} className={classes.buttonsGroup}>
											<ImportFile />
										</Button>
									</Tooltip>
								</Authorization>
							</>
						</Authorization>
					)}
				</ButtonGroup>
				<div className={classes.searchRoot}>
					<SearchBox placeholder='Search ticket or model' onChange={onChangeSearchValue} value={searchValue} />
				</div>
			</div>

			<DataGrid
				headers={props.configuration}
				data={props.services}
				isLoading={props.isLoading}
				className={classes.table}
				sortBy={props.sortBy}
				sortDirection={props.sortDirection}
				onChangeSortingCriteria={props.onchangeSortingCriteria}
				onItemClick={onRowClick}
			/>
		</>
	)
}
ServicesTable.propTypes = {
	/**
	 * The list of services
	 */
	services: propTypes.arrayOf(
		propTypes.shape({
			Ticket: propTypes.any.isRequired
		})
	).isRequired,
	/**
	 * Callback executed when the user change the orden criteria
	 */
	onchangeSortingCriteria: propTypes.func.isRequired,
	/**
	 * Determine the sorting column for the service table
	 */
	sortBy: propTypes.string,
	/**
	 * The sort direction
	 */
	sortDirection: propTypes.oneOf(['asc', 'desc']),
	/**
	 * Determine if is loading the services list
	 */
	isLoading: propTypes.bool.isRequired,
	serviceProviders: propTypes.array,
	salesRepresentatives: propTypes.array,
	/**Fuct to redirect to view for creatae service */
	redirectToCreateService: propTypes.func,
	isServicesOpen: propTypes.bool.isRequired,
	/**
	 * The filter configuration array with visible and order properties
	 */
	filterConfiguration: propTypes.array,
	/**
	 * Callback executed when the user saves the filter configuration
	 */
	onFilterConfigurationChange: propTypes.func,
	onDownloadOpenServicesJson: propTypes.func
}
ServicesTable.defaultProps = {
	services: [],
	salesRepresentatives: [],
	serviceProviders: [],
	retails: [],
	internalUsers: [],
	isLoading: false,
	isServicesOpen: true,
	filterConfiguration: [],
	onFilterConfigurationChange: null,
	onDownloadOpenServicesJson: () => console.warn('Callback [onDownloadOpenServicesJson] no defined')
}
export default ServicesTable
